import React, { useEffect, useState } from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import AddressModal from "./AdderssModal";
import axios from "axios";
import Popup from "reactjs-popup";
import OneDayDelivery from "./OneDayDelivery";
import Cookies from "js-cookie";

interface estimateDeliveryProps {
  delivery_date?: string;
  address?: string;
  zip_code?: number;
  city?: string;
  phone?: string;
  first_name?: string;
  cart_id?: any;
}

const EstimateDelivery = (props: estimateDeliveryProps) => {

  const oneDayDelivery = Cookies.get("utmSource");

  const {
    getCartData,
    handleModal,
    modalOpenData,
    openPopup,
    closePopup,
    setError,
  } = useShoppingCart();
  const data = getCartData;
  const address_customer = data?.data[0].customer.addresses;
  // console.log(address_customer);

  const handleClick = () => {
    // console.log("address two three");
    openPopup("address");
  };

  // console.log(modalOpenData, "satyendra");
  // const [modalOpen, setModalOpen] = useState(false);

  const [pinData, setPinData] = useState<any>(null);

  let sku = "";
  if (data && data?.data[0].temp_cart_items) {
    sku = data?.data[0].temp_cart_items[0].sku;
  }
  useEffect(() => {
    const fetchData = async () => {
      const productSKU = sku;
      const pinCode = props.zip_code;
      const bearerToken = "684f4022322f26447d6210af777793d2";

      const url = `https://backend.aqualens.in/api/v1/products/${productSKU}/country/IN/pincode/${pinCode}/estimated-delivery`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });

        setPinData(response.data);
        // console.log(response.data, "dfghjkl"); // Handle the response data here
      } catch (error) {
        console.error(error); // Handle any errors that occur during the request
      }
    };

    fetchData();
  }, [props.zip_code]);

  // console.log(pinData, "pinData");
  const deliveryDate = pinData;
  const is_one_day_delivery = deliveryDate?.data?.is_one_day_delivery;


  if (props.first_name === undefined || props.first_name === null) {
    return <></>;
  } else {
    return (
      <>
        <div className="deliveryEstimateWrapper">
          <div className="deliveryEstimateWrapperContent">
            <div className="deliveryDate">
              <div style={{ marginTop: "6px" }}>
                <svg
                  width="19"
                  height="22"
                  viewBox="0 0 19 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.12 7.45C17.07 2.83 13.04 0.75 9.49997 0.75C9.49997 0.75 9.49997 0.75 9.48997 0.75C5.95997 0.75 1.91997 2.82 0.869973 7.44C-0.300027 12.6 2.85997 16.97 5.71997 19.72C6.77997 20.74 8.13997 21.25 9.49997 21.25C10.86 21.25 12.22 20.74 13.27 19.72C16.13 16.97 19.29 12.61 18.12 7.45ZM9.49997 12.46C7.75997 12.46 6.34997 11.05 6.34997 9.31C6.34997 7.57 7.75997 6.16 9.49997 6.16C11.24 6.16 12.65 7.57 12.65 9.31C12.65 11.05 11.24 12.46 9.49997 12.46Z"
                    fill="#469DA1"
                  />
                </svg>
              </div>
              <div>
                <div className="deliveryAddressWrap">
                  {/* <span className="deliveryText">Delivering to: </span> */}
                  <span className="deliveryAddress">
                    {props.first_name}, {props.address}, {props.city},{" "}
                    {props.zip_code}
                  </span>
                </div>
                {deliveryDate && deliveryDate?.status == "SUCCESS" ? (
                  <div className="estimatedDate">
                    Order <span className="deliveryTag">Now</span> to receive
                    it by{" "}
                    <span className="deliveryTag">
                      {deliveryDate.data?.delivery_date}
                    </span>
                  </div>
                ): <div className="estimatedDate">
                  Order <span className="deliveryTag">Now</span> to receive
                  it by{" "}
                  <span className="deliveryTag">
                    4 days.
                  </span>
              </div>
                }
              </div>
            </div>
            {/* <button onClick={() => { handleModal(true) }} >Change</button> */}

              <button onClick={() => { handleClick(); setError() }} >Change</button>
          </div>
        </div>



        {modalOpenData && modalOpenData.isPopup &&  modalOpenData.popupId=="address" && <AddressModal  cart_id={props.cart_id} />}

      {/* { oneDayDelivery && is_one_day_delivery && oneDayDelivery !== '' &&  is_one_day_delivery &&
                <OneDayDelivery />
              } */}

      </>
    );

  }
};

export default EstimateDelivery;
